export type TJobsReportListParams = {
  page: number;
  pageSize: number;
  search: string;
  jobsFrom: string;
  jobsTo: string;
};

export type TUserJobsReportListParams = {
  page: number;
  pageSize: number;
  jobsFrom: string;
  jobsTo: string;
};

export const reportsKeys = {
  all: [{ module: 'reports' }] as const,
  workspaceJobs: () => [{ ...reportsKeys.all[0], scope: 'workspaceJobs' }] as const,
  workspaceJobsByWorkspace: (workspaceId: string) => [{ ...reportsKeys.workspaceJobs()[0], workspaceId }] as const,
  workspaceJobsList: (workspaceId: string, params: TJobsReportListParams) =>
    [{ ...reportsKeys.workspaceJobsByWorkspace(workspaceId)[0], params }] as const,
  userJobs: () => [{ ...reportsKeys.all[0], scope: 'userJobs' }] as const,
  userJobsByUser: (workspaceId: string, userId: string) =>
    [{ ...reportsKeys.userJobs()[0], workspaceId, userId }] as const,
  userJobsList: (workspaceId: string, userId: string, params: TUserJobsReportListParams) =>
    [{ ...reportsKeys.userJobsByUser(workspaceId, userId)[0], params }] as const,
};
